import React from 'react';
import { ListItemText, Typography } from '@mui/material';

/**
 * Benutzerdefinierte ListItemText-Komponente, die HTML-Validierungsfehler vermeidet,
 * indem sie verschachtelte p-Tags verhindert.
 */
const CustomListItemText = ({ primary, secondary, ...rest }) => {
  // Wir rendere die primary und secondary Inhalte als div-Elemente, 
  // um verschachtelte p-Tags zu vermeiden
  return (
    <ListItemText
      primary={
        typeof primary === 'string' ? (
          primary
        ) : (
          // Wenn primary kein String ist, nehmen wir an, dass es JSX ist
          // und umschließen es mit einem div, um verschachtelte p-Tags zu vermeiden
          <div className="primary-content">{primary}</div>
        )
      }
      secondary={
        secondary && (
          typeof secondary === 'string' ? (
            secondary
          ) : (
            // Wenn secondary kein String ist, nehmen wir an, dass es JSX ist
            // und umschließen es mit einem div, um verschachtelte p-Tags zu vermeiden
            <div className="secondary-content">{secondary}</div>
          )
        )
      }
      {...rest}
    />
  );
};

export default CustomListItemText;